import { Injectable } from '@angular/core';

@Injectable()
export class EncryptionService{
  constructor() { }

  encryptionAES(encryptStr: any) {
    //TODO add logic
    return encryptStr;
  }
  decryptionAES(decryptStr: any) {
    //TODO add logic
    return decryptStr;
  }
}
